import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { constantvalues } from "../../../const";
import { environment } from "../../environments/environment.development";
import { MetricDetails } from "../../../models/package-center.model";

@Injectable({
    providedIn: 'root'
})

export class MetricsService {
    baseURL: string;
    constructor(private httpClient: HttpClient) {
        this.baseURL = environment.gatewayUrl;
    }
    getMetrics(sectorId: number, payload: any) {
        return this.httpClient.get(`${this.baseURL}${constantvalues.API_URL.CRUD_METRICS}/${sectorId}`, {params: payload});
    }

    updateMetricStatus(metricId: number) {
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_METRICS}/${metricId}`, null);
    }

    updateMetricName(metricDetail: MetricDetails) {
        return this.httpClient.put(`${this.baseURL}${constantvalues.API_URL.CRUD_METRICS}`, metricDetail);
    }

    deleteMetric(metricId: number) {
        return this.httpClient.delete(`${this.baseURL}${constantvalues.API_URL.CRUD_METRICS}`, {
            params: {
                metricId: metricId
            }
        });
    }
}